import { getToken } from "./tokens";
import { ENV_CONFIG } from "./config";
// export const url = "http://localhost:3010/";
// export const url = "https://spilve-be.demo-zone.site/";
// export const url = "https://ppr-be.spilve.org/";

export const url = ENV_CONFIG.API_URL;

const handleResponse = async (response) => {
  if (response.status === 200 || response.status === 201) {
    return await response.json();
  } else if (response.status === 404) {
    return { error: "Not found" };
  } else if (response.status === 400) {
    return { error: "error" };
  } else if (response.status === 401) {
    window.location.href = "/logout";
  }
};

const fetchInside = async (route, token, method, data) => {
  const options = {
    method,
    headers: {
      ...(token ? { Authorization: token } : {}),
      "Content-Type": "application/json",
    },
  };

  if (method !== "GET" && data) {
    options.body = JSON.stringify(data);
  }

  const response = await fetch(url + route, options);
  return handleResponse(response);
};

// Enhanced helper functions
const getAuth = async (route, data = null) => {
  const token = getToken();
  return fetchInside(route, token, "GET", data);
};

const postAuth = async (route, data = null) => {
  const token = getToken();
  return fetchInside(route, token, "POST", data);
};

const putAuth = async (route, data = null) => {
  const token = getToken();
  return fetchInside(route, token, "PUT", data);
};

const deleteAuth = async (route, data = null) => {
  const token = getToken();
  return fetchInside(route, token, "DELETE", data);
};

const get = async (route, data = null) => {
  return fetchInside(route, null, "GET", data);
};

const post = async (route, data = null) => {
  return fetchInside(route, null, "POST", data);
};

export const handleLogin = async (email, password) => {
  const response = await fetch(url + "auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return response;
};

// Auth functions
export const registerUser = (data) => post("auth/register", data);
export const checkEmailOrPhone = (data) => post("auth/check-availability", data);
export const sentVerifyNumberRequest = (data) => post("auth/verify-sms", { phone: "+" + data });
export const verifyReceivedSMSCode = (phone, code) => post("auth/verify-code", { phone: "+" + phone, code: code });

// ==================== FLIGHT REQUEST FUNCTIONS ====================
export const requestSingleFlight = (data) => {
  const requestData = {
    full_name: data.full_name,
    email: data.email,
    phone: data.phone,
    aircraft_registration: data.aircraft_registration,
    aircraft_type: data.aircraft_type,
    flight_type: data.flight_type,
    departure_place: data.departure_place,
    arrival_place: data.arrival_place,
    flight_date: data.flight_date,
    requester_number: data.requester_number || data.phone,
    requester_email: data.requester_email || data.email,
    plane_number: data.plane_number || data.aircraft_registration,
    plane_type: data.plane_type || data.aircraft_type,
    dof: data.dof || data.flight_date,
    purpose_of_flight: data.purpose_of_flight || "PRIVATE",
    ppr_type: data.ppr_type || "one_time",
    payment_method: data.payment_method || "online",
    rules_acknowledged: data.rules_acknowledged || false,
    quiz_completed: data.quiz_completed || false,
    quiz_score: data.quiz_score || 0,
    pricing_amount: data.pricing_amount,
    currency: data.currency,
    requires_payment: data.requires_payment,
  };
  return post("request/create", requestData);
};


export const requestLoggedInFlight = (data) => {
  const requestData = {
    aircraft_registration: data.aircraft_registration,
    aircraft_type: data.aircraft_type,
    flight_type: data.flight_type,
    departure_place: data.departure_place,
    arrival_place: data.arrival_place,
    flight_date: data.flight_date,
    departure_time: data.departure_time,
    plane_number: data.plane_number || data.aircraft_registration,
    plane_type: data.plane_type || data.aircraft_type,
    dof: data.dof || data.flight_date,
    purpose_of_flight: data.purpose_of_flight || "PRIVATE",
    ppr_type: data.ppr_type || "one_time",
    payment_method: data.payment_method || "online",
    pricing_amount: data.pricing_amount, // NEW
    customer_ip: data.customer_ip || window.location.hostname, // NEW
    email: data.email, // NEW
    phone: data.phone, // NEW
  };
  return postAuth("request/create-logged-in", requestData);
};

export const getUserRequests = () => getAuth("request/my-requests");

export const getFlightHistory = (options = {}) => {
  const userId = options.userId;
  return getAuth(`users/${userId}/flights`);
};

export const validatePPR = (ppr_number, plane_number, dof) =>
  post("request/validate-ppr", { ppr_number, plane_number, dof });

export const getFlightPurposes = () => get("request/flight-purposes");

// ==================== PAYMENT FUNCTIONS ====================
export const getPaymentLink = (data) => post("payment/create-link", data);
export const getPaymentStatus = (data) => postAuth("payment/status", data);
export const getUserCredits = () => getAuth("payment/credits");

export const confirmManualPayment = (ppr_number, amount, payment_method, staff_id, notes) =>
  post("payment/confirm-manual", { ppr_number, amount, payment_method, staff_id, notes });

// ==================== QUESTIONS AND RULES FUNCTIONS ====================
export const getClientQuestions = (data) => post("resources/questions/quiz", data);
export const submitQuizAnswers = (data) => post("resources/questions/submit", data);
export const saveQuestions = (data) => postAuth("resources/questions", data);
export const getQuestions = () => getAuth("resources/questions");
export const getRules = () => get("resources/rules");
export const saveRules = (data) => postAuth("resources/rules", { data: data });
export const getRulesRead = () => getAuth("users/rules");
export const setRulesRead = () => postAuth("users/rules/accept");

// ==================== AIRCRAFT MANAGEMENT FUNCTIONS ====================
export const getUserAirplanes = () => getAuth("planes");
export const createAirplane = (data) => postAuth("planes/", data);
export const saveAirplane = (data) => putAuth(`planes/${data.plane_id}`, data);

export const searchUsers = (searchTerm) =>
  getAuth(`users/search?q=${encodeURIComponent(searchTerm)}`);

// ==================== ADMIN FUNCTIONS ====================
export const getUserRequestsAdmin = (data = {}) => {
  const queryParams = new URLSearchParams(data).toString();
  return getAuth(`admin/flight-requests?${queryParams}`);
};

export const getUserRequestCountAdmin = () => getAuth("admin/dashboard/stats");
export const confirmUserFlight = (data) => postAuth(`admin/flight-requests/${data.id}/confirm`, data);
export const cancelUserFlight = (data) => postAuth(`admin/flight-requests/${data.id}/decline`, data);

// ==================== PPR CATEGORIES FUNCTIONS ====================
export const getPPRCategories = () => get("resources/ppr-categories");
export const createPPRCategory = (data) => postAuth("resources/ppr-categories", data);
export const updatePPRCategory = (data) => putAuth(`resources/ppr-categories/${data.category_id}`, data);

// ==================== STANDS FUNCTIONS ====================
export const createStand = (standData) => postAuth("admin/stands", standData);
export const updateStand = (standId, standData) => putAuth(`stands/${standId}`, standData);

export const getStandBilling = (filters = {}) => {
  const queryParams = new URLSearchParams(filters).toString();
  return getAuth(`stands/billing?${queryParams}`);
};

export const getUserExemptions = (userId = null) => getAuth(`admin/users/${userId}/exemptions`);
export const markBillingAsPaid = (billingId, paymentData) =>
  postAuth(`stands/admin/billing/${billingId}/paid`, paymentData);

export const createStandReservation = (reservationData) =>
  postAuth("stands/admin/reservations", reservationData);

export const assignAircraftToStand = (standId, aircraftData) =>
  postAuth("stands/occupancy", { stand_id: standId, ...aircraftData });

export const removeAircraftFromStand = (occupancyId, releaseData = {}) =>
  postAuth(`stands/occupancy/${occupancyId}/release`, releaseData);

export const getMyStandReservations = () => getAuth("stands/my-reservations");
export const getOccupancyOverview = () => getAuth("stands");
export const getUserCreditStatus = (userId = null) => getAuth(`users/${userId}/credit-status`);
export const getPendingPPRApprovals = () => getAuth("admin/ppr-approvals/pending");

// ==================== PRICING FUNCTIONS ====================
export const getPPRPricingByType = (flightType, pprType = "one_time", weightCategory = null) => {
  let endpoint = `pricing/ppr/${flightType}?ppr_type=${pprType}`;
  if (weightCategory) endpoint += `&weight_category=${weightCategory}`;
  return getAuth(endpoint);
};

export const getAllPPRPricing = () => getAuth("pricing/ppr");
export const getActiveCreditPackages = () => getAuth("pricing/packages");

export const getAdminPPRPricing = (includeInactive = false) =>
  getAuth(`pricing/ppr?include_inactive=${includeInactive}`);

export const createPPRPricing = (pricingData) => postAuth("pricing/admin/ppr", pricingData);
export const updatePPRPricing = (pricingId, updateData) =>
  putAuth(`pricing/ppr/${updateData.pricing_id}`, updateData);

export const deactivatePPRPricing = (pricingId) => deleteAuth(`pricing/ppr/${pricingId}`);

export const getAdminCreditPackages = (includeInactive = false) =>
  getAuth(`pricing/admin/packages?include_inactive=${includeInactive}`);

export const createCreditPackage = (packageData) => postAuth("pricing/admin/packages", packageData);
export const updateCreditPackage = (updateData) =>
  putAuth(`pricing/admin/packages/${updateData.package_id}`, updateData);

export const getStandPricing = () => getAuth("pricing/stands");
export const updateStandPricing = (updates) => putAuth("pricing/stands/pricing", { updates });

export const getPricingAnalytics = (dateRange = {}) => {
  const queryParams = new URLSearchParams(dateRange).toString();
  return getAuth(`pricing/analytics?${queryParams}`);
};

export const getPricingCategories = () => get("pricing/categories");

// Aliases for backwards compatibility
export const getPPRPricing = (flight_type, ppr_type = "one_time", weight_category = null) =>
  getPPRPricingByType(flight_type, ppr_type, weight_category);
export const getCreditPackages = () => getActiveCreditPackages();

// ==================== USER PROFILE FUNCTIONS ====================
export const getUserProfile = () => getAuth("user-profile/profile");
export const updateUserProfile = (profileData) => putAuth("user-profile/profile", profileData);
export const changePassword = (passwordData) => postAuth("user-profile/change-password", passwordData);

// Two-Factor Authentication
export const setup2FA = () => postAuth("user-profile/2fa/setup");
export const enable2FA = (tokenCode) => postAuth("user-profile/2fa/enable", { token: tokenCode });
export const disable2FA = (password, tokenCode) =>
  postAuth("user-profile/2fa/disable", { password, token: tokenCode });

// Phone verification
export const sendPhoneVerification = () => postAuth("user-profile/verify-phone/send");
export const verifyPhoneNumber = (code) => postAuth("user-profile/verify-phone/confirm", { code });

// User preferences and security
export const updateUserPreferences = (preferences) => putAuth("user-profile/preferences", preferences);
export const getSecuritySettings = () => getAuth("user-profile/security");

export const getUserActivity = (page = 1, limit = 10) =>
  getAuth(`user-profile/activity?page=${page}&limit=${limit}`);

// ==================== INVOICE FUNCTIONS ====================
export const getUserInvoices = (page = 1, limit = 10, filters = {}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    ...filters,
  });
  return getAuth(`invoices/my-invoices?${params}`);
};

export const getInvoiceDetails = (invoiceId) => getAuth(`invoices/${invoiceId}`);

export const getAllInvoicesAdmin = (page = 1, limit = 10, filters = {}) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    ...filters,
  });
  return getAuth(`invoices/admin/all?${params}`);
};

export const generateInvoiceAdmin = (transactionId, options = {}) =>
  postAuth("invoices/admin/generate", { transaction_id: transactionId, ...options });

export const updateInvoiceStatusAdmin = (invoiceId, status, notes = null) =>
  putAuth(`invoices/admin/${invoiceId}/status`, { status, notes });

export const markInvoiceAsPaidAdmin = (invoiceId, paymentData) =>
  postAuth(`invoices/admin/${invoiceId}/mark-paid`, paymentData);

export const cancelInvoiceAdmin = (invoiceId, reason = null) =>
  postAuth(`invoices/admin/${invoiceId}/cancel`, { reason });

export const bulkGenerateInvoicesAdmin = (transactionIds, sendEmails = false) =>
  postAuth("invoices/admin/bulk-generate", {
    transaction_ids: transactionIds,
    send_emails: sendEmails,
  });

// ==================== PUBLIC PRICING FUNCTIONS ====================
export const getPPRPricingByTypeUnregistered = (flightType, pprType = "one_time", weightCategory = null) => {
  let endpoint = `request/pricing/ppr/${flightType}?ppr_type=${pprType}`;
  if (weightCategory) endpoint += `&weight_category=${weightCategory}`;
  return get(endpoint);
};

export const getFlightTrack = () => getAuth("request/flight-track");

// At the end of the file, add:

export const createEveryPayLink = (data) => post("payment/create-link", data);

export const checkPaymentByOrder = (orderReference) =>
  get(`payment/status/${orderReference}`);

export const checkEveryPayStatus = (paymentReference) =>
  post("payment/check-everypay-status", { payment_reference: paymentReference });

export const getAllPPRPricingUnregistered = () => get("request/pricing/ppr");

// ==================== ADMIN REPORT FUNCTIONS ====================
export const downloadInvoiceReport = async (startDate, endDate) => {
  const token = getToken();
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });
  const response = await fetch(
    `${url}invoices/admin/report/download?${params}`,
    {
      method: "GET",
      headers: {
        Authorization: token,
      },
    }
  );

  if (!response.ok) {
    const errData = await response.json().catch(() => ({}));
    throw new Error(errData.message || "Failed to download report");
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = `invoices-${startDate}-to-${endDate}.zip`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(downloadUrl);
};